import type { SizeSystemType } from '@rover/kibble/core/styledSystemPropTypes';

/* This is intended to match the existing PageLayout widths exactly.
 * These values are 30px fewer than PageLayout's written widths because
 * PageLayout's padding eats into its content area, while Section's doesn't.
 *
 * Once we've fully removed PageLayout, this should be updated to better match
 * current design standards.
 */
export const PAGE_WIDTHS: SizeSystemType = ['720px', '720px', '940px', '1140px'];
